module.exports = __webpack_public_path__ + "static/media/mystino_kingdom.octoplay.9244d8e8.jpeg";